"use strict";

var BlsComparePageShopify = (function () {
  return {
    initCompareItems: function () {
      this.init();
    },

    // Hide any spec row (class compare-row-spec-*) that has no real value
    // across all currently-compared products, so rubbers show rubber specs,
    // blades show blade specs, etc. Built-in rows (basic/review/vendor/
    // color/size/availability) are never touched because they don't carry
    // the "spec-" token. Called on initial stitch AND after every removal.
    refreshSpecRows: function () {
      const table = document.querySelector(
        ".compare-page-main .compare-table"
      );
      if (!table) return;
      table
        .querySelectorAll("[class*='compare-row-spec-']")
        .forEach((row) => {
          let hasData = false;
          row.querySelectorAll(".compare-value").forEach((v) => {
            const txt = v.textContent.trim();
            if (txt && txt !== "-") hasData = true;
          });
          row.style.display = hasData ? "" : "none";
        });
    },

    init: function () {
      const compare_items = JSON.parse(
        localStorage.getItem("milano__compare-items")
      );
      const compareDiv = document.querySelector(".compare-page-main");
      const div_no_product = compareDiv.querySelector(".compare-no-product-js");
      if (compare_items === null || compare_items.length === 0) {
        div_no_product.classList.remove("hidden");
      } else {
        var query = "";
        compare_items.forEach((e, key, compare_items) => {
          if (!Object.is(compare_items.length - 1, key)) {
            query += e + "%20OR%20id:";
          } else {
            query += e;
          }
        });
        const section_id = document.querySelector(".compare-page-section")
          .dataset.sectionId;
        var productAjaxURL =
          "?section_id=" +
          section_id +
          "&type=product&options[unavailable_products]=last&q=id:" +
          query;
        fetch(`${window.routes.search_url}${productAjaxURL}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = parser.parseFromString(responseText, "text/html");
            const table = compareDiv.querySelector(".compare-table");

            if (compare_items.length !== 0) {
              const bpc = html.querySelectorAll(
                ".compare-page-section > .product-compare"
              );

              if (bpc.length > 0 && table) {
                // Re-run safety: drop any previously-stitched value cells.
                table
                  .querySelectorAll(".compare-value")
                  .forEach((ei) => ei.remove());

                // --- Generic stitch ---------------------------------------
                // For every product block, copy each .compare-row-* cell into
                // the matching label row in the table, matched purely by class
                // name. This means any row added in page-compare.liquid (e.g.
                // a new metafield spec row) is picked up automatically -- no
                // edits to this file are ever needed again.
                bpc.forEach((el) => {
                  el
                    .querySelectorAll(":scope > [class*='compare-row-']")
                    .forEach((rowDiv) => {
                      const rowClass = Array.from(rowDiv.classList).find((c) =>
                        c.startsWith("compare-row-")
                      );
                      if (!rowClass) return;
                      const target = table.querySelector("." + rowClass);
                      if (target) target.innerHTML += rowDiv.innerHTML;
                    });
                });

                // --- Adaptive rows ----------------------------------------
                this.refreshSpecRows();

                table.classList.remove("hidden");
              } else {
                div_no_product.classList.remove("hidden");
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally((e) => {});
      }
    },
  };
})();
BlsComparePageShopify.initCompareItems();

class CompareRemove extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.productHandle = this.dataset.productHandle;
    this.init();
  }
  init() {
    this.addEventListener("click", this.onThisClick.bind(this));
  }
  onThisClick() {
    const localListProductIds = localStorage.getItem("milano__compare-items");
    const allThisProductIds = document.querySelectorAll(
      `compare-remove[data-product-id="${this.productId}"]`
    );
    let listProductIds = [];
    if (!this.productId) return;
    if (localListProductIds && allThisProductIds.length > 0) {
      // compare localstorage exists
      const parseLocalListProductIds = JSON.parse(localListProductIds);
      const indexOfProductId = parseLocalListProductIds.indexOf(this.productId);
      parseLocalListProductIds.splice(indexOfProductId, 1);
      listProductIds.push(...parseLocalListProductIds);
      const product_remove = document.querySelectorAll(
        `[data-product-handle="${this.productHandle}"]`
      );
      product_remove.forEach((e) => {
        e.remove();
      });
      // Re-evaluate spec rows: fields with no remaining data should disappear.
      BlsComparePageShopify.refreshSpecRows();
      if (JSON.parse(localListProductIds).length == 1) {
        const compareDiv = document.querySelector(".compare-page-main");
        const div_no_product = compareDiv.querySelector(".compare-no-product-js");
        const compare_table = compareDiv.querySelector(".compare-table");
        div_no_product.classList.remove("hidden");
        compare_table.remove();
      }
    }
    const stringifyListProductIds = JSON.stringify(listProductIds);
    localStorage.setItem("milano__compare-items", stringifyListProductIds);
  }
}
customElements.define("compare-remove", CompareRemove);
